import EmployeeForm from '../pages/admin/personnel/addNewEmployee/EmployeeForm'
import DBSDashboard from '../pages/admin/personnel/DBS/Dashboard'
import EmployeeDashboard from '../pages/admin/personnel/employeeDashboard/employeeDashboard'
import MandatoryTrainingReview from '../pages/admin/personnel/employeeDashboard/MandatoryTrainingReview'
import Employees from '../pages/admin/personnel/employees'
import EmployeeSingle from '../pages/admin/personnel/employeeSingle/employeeSingle'
import TrainingMatrix from '../training/pages/admin/TrainingMatrix'
import Payroll from '../pages/admin/personnel/payroll/Payroll'
import GlobalRoster from '../pages/admin/personnel/GlobalRoster/GlobalRoster'
import Availability from '../pages/availability/Availability'
import ShiftApplicationHistory from '../pages/admin/personnel/ShiftApplicationHistory/ShiftApplicationHistory'
import ShiftApplicationView from '../pages/admin/personnel/ShiftApplicationHistory/ShiftApplicationView'
import ApplicationsDashboard from '../pages/applications/admin/Applications'
import EmployeeApplication from '../pages/applications/admin/EmployeeApplication'
import ReferenceRequest from '../pages/applications/referenceRequest/ReferenceRequest'
import MyMandatoryTraining from '../pages/userPages/myMandatoryTraining/MyMandatoryTraining'
import Subcontractors from '../pages/admin/personnel/Subcontractors'
import SubcontractorSingle from '../pages/admin/personnel/SubcontractorSingle'
import MyAppraisals from '../pages/userPages/myAppraisals/MyAppraisals'
import AppraisalsPendingReview from '../pages/admin/personnel/employeeDashboard/AppraisalsPendingReview'
import MyOccupationalHealth from '../pages/userPages/occupationalHealth/MyOccupationalHealth'
import OccupationalHealthDashboard from '../pages/admin/personnel/occupationalHealth/OccupationalHealthDashboard'

export default [
  { path: '/employeesdashboard', element: <EmployeeDashboard />, title: 'Employees' },
  { path: '/occupational-health', element: <OccupationalHealthDashboard />, title: 'Occupational Health' },
  { path: '/employees', element: <Employees />, title: 'Employees' },
  { path: '/employees/subcontractors', element: <Subcontractors />, title: 'Subcontractors' },
  {
    path: '/employees/subcontractors/:subcontractorId',
    element: <SubcontractorSingle />,
  },
  { path: '/dbs-checks', element: <DBSDashboard />, title: 'DBS Checks' },
  { path: '/employees/:userId', element: <EmployeeSingle /> },
  {
    path: '/employees/new',
    element: <EmployeeForm isNew={true} isSelf={false} onClose={() => {}} />,
    title: 'New Employee'
  },
  { path: '/employees/mandatory-training', element: <TrainingMatrix />, title: 'Training matrix' },
  { path: '/employees/applications', element: <ApplicationsDashboard />, title: 'Applications' }, // TODO - SubscriptionGate
  { path: '/employees/applications/:id', element: <EmployeeApplication /> }, // TODO - SubscriptionGate
  {
    path: '/shift-application-history/:employeeID',
    element: <ShiftApplicationHistory />, // TODO - SubscriptionGate
  },
  {
    path: '/shift-application-history/:employeeID/:applicationID',
    element: <ShiftApplicationView />, // TODO - SubscriptionGate
  },
  { path: '/employees/payroll', element: <Payroll />, title: 'Payroll' }, // TODO - SubscriptionGate
  { path: '/global-roster', element: <GlobalRoster />, title: 'Global Roster' }, // TODO - SubscriptionGate
  {
    path: '/employees/availability',
    element: <Availability manager />,
    title: 'Availability'
  },
  { path: '/reference-response', element: <ReferenceRequest />, title: 'References'}, // TODO - SubscriptionGate
  { path: '/mandatory-training', element: <MyMandatoryTraining />, title: 'Mandatory Training' },
  { path: '/pending-mandatory-training', element: <MandatoryTrainingReview />, title: 'Mandatory Training' },
  { path: '/my-appraisals', element: <MyAppraisals />, title: 'My Appraisals' },
  { path: '/my-occupational-health', element: <MyOccupationalHealth />, title: 'Occupational Health' },
  { path: '/appraisals/pending-review', element: <AppraisalsPendingReview />, title: 'Appraisals' },
  // { path: '/uniform-store', element: <UniformStore /> },
  // { path: '/uniform-store/add', element: <AddUniform /> },
  // { path: '/uniform-store/issue', element: <IssueUniformItem /> },
  // { path: '/employee/medical/declaration', element: <DeclarationForm /> },
]
